import React, { useEffect, useState } from "react";
import "react-horizontal-scrolling-menu/dist/styles.css";

import Spinner from "../../components/loaders/Spinner";
import StatsCards from "./StatsCards";
import MintGoldTokens from "./MintGoldTokens";
import TransactionMonitor from "./TransactionMonitor";
import ComplianceVerification from "./ComplianceVerification";
import PurchaseManagement from "./PurchaseManagement";
import TransactionHistory from "./TransactionHistory";
import SystemAlerts from "./SystemAlerts";
import * as api from "../../redux/api";

const DashboardLanding = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [goldData, setGoldData] = useState([]);

  // const getAllStages = async () => {
  //   setIsLoading(true);
  //   const res = await api.getStages();
  //   const { status, data } = res;
  //   if (status >= 200 && status < 300) {
  //     setStages(data);
  //     setIsLoading(false);
  //   } else {
  //     setIsLoading(false);
  //     toast.error(data.message);
  //   }
  // };
  useEffect(() => {
    // getAllStages();
    setIsLoading();
  }, []);

  useEffect(() => {
    const fetchGoldPrices = async () => {
      try {
        const response = await api.getGoldPrices();
        if (response.status) {
          setGoldData(response.data);
        }
      } catch (error) {
        console.error("Error fetching gold prices:", error);
      }
    };
    fetchGoldPrices();
  }, []);
  console.log("first", goldData);
  return (
    <>
      {isLoading && <Spinner />}
      <div className="container">
        <div className="upper rounded-lg flex justify-between ">
          <h4 className="flex items-center gap-2 mb-4 ">Dashboard</h4>
          <div className="border p-4 px-6 border-[#D3B25B] bg-[#F2DEAC] rounded-md relative ">
            <p className="font-poppins text-28 leading-6 font-normal text-black pb-2">
              {goldData?.price ? `$${goldData?.price}` : "Loading..."}
            </p>
            <p className="text-[#8D8D8D]  font-poppins font-medium text-16 leading-4">
              Current Gold Market Rate
            </p>
            <div className="  absolute -left-5 top-5">
              <img
                src="/images/Dashboard/dashboardgold.svg"
                alt="saurabh"
                className="  bg-white p-2 border border-[#D3B25B] rounded-full text-28"
              />
            </div>
          </div>
        </div>
        <div className="mt-6 rounded-lg">
          <StatsCards />
        </div>
        <div className="rounded-lg mt-6">
          <h4 className="font-poppins font-semibold text-18 leading-4 pb-6">
            Gold Storage Overview
          </h4>
          <div className="grid grid-cols-2 gap-7  ">
            <MintGoldTokens />
            <TransactionMonitor />
            <ComplianceVerification />
            <PurchaseManagement />
          </div>
        </div>

        <div className="mt-16">
          <TransactionHistory />
        </div>
        <div className="mt-16">
          <SystemAlerts />
        </div>
      </div>
    </>
  );
};
export default DashboardLanding;
